import * as React from 'react';
import { connect } from 'react-redux';
import { setTimeShow, setIsCar, setStep, getClaimDamagePhotoTypes, handleStepBack, handleNextStep } from '../../../actions/claimSubmitActions';
import { isMobile } from 'react-device-detect';
import '../../FNOL/FNOL.css'
import { PORTABLE_POSSESSION_PRODUCT_ID, CHILLI_COMPREHENSIVE_PRODUCT_ID, MOTOR_COMPREHENSIVE_PRODUCT_ID, MOTORBIKE_COMPREHENSIVE_PRODUCT_ID } from '../../../constants/products';

const getCarPhotos = 6;
const getMotorbikePhohotos = 7;

class FnolStep1Sub3 extends React.Component<any, any>  {

    constructor(props) {
        super(props);
        this.state = {
            fnolStep: this.props.claimSubmit.selectedClaimStep.step,
            fnolSubStep: this.props.claimSubmit.selectedClaimStep.subStep,
            selectedCover: null,
            coverToggle: false,
            IncidentToggle: false,
            nextDisabled: true,
        };
        this.handleIsDrivable = this.handleIsDrivable.bind(this);
        this.handleIsDrivableYes = this.handleIsDrivableYes.bind(this);
        this.handleIsDrivableMobile = this.handleIsDrivableMobile.bind(this);
    }

    handleIsDrivableYes() {
        this.props.dispatchSetStep(5, 1);
    }

    async handleIsDrivable() {
        if (this.props.claimSubmit.selectedRiskItem.product === MOTOR_COMPREHENSIVE_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === CHILLI_COMPREHENSIVE_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === PORTABLE_POSSESSION_PRODUCT_ID) {
            await this.setState({
                isCar: true,
            })
            await this.props.dispatchSetIsCar(true);
        }
        else if (this.props.claimSubmit.selectedRiskItem.product === MOTORBIKE_COMPREHENSIVE_PRODUCT_ID) {
            await this.setState({
                isCar: false,
            })
            await this.props.dispatchSetIsCar(false);
        }
        this.props.claimSubmit.isCar ? await this.props.dispatchGetClaimDamagePhotoTypes(getCarPhotos) : await this.props.dispatchGetClaimDamagePhotoTypes(getMotorbikePhohotos);
        await this.props.dispatchHandleNextStep();
    }

    async handleIsDrivableMobile() {
        if (this.props.claimSubmit.selectedRiskItem.product === MOTOR_COMPREHENSIVE_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === CHILLI_COMPREHENSIVE_PRODUCT_ID || this.props.claimSubmit.selectedRiskItem.product === PORTABLE_POSSESSION_PRODUCT_ID) {
            await this.setState({
                isCar: true,
            })
            await this.props.dispatchSetIsCar(true);
        }
        else if (this.props.claimSubmit.selectedRiskItem.product === MOTORBIKE_COMPREHENSIVE_PRODUCT_ID) {
            await this.setState({
                isCar: false,
            })
            await this.props.dispatchSetIsCar(false);
        }
        this.props.claimSubmit.isCar ? await this.props.dispatchGetClaimDamagePhotoTypes(getCarPhotos) : await this.props.dispatchGetClaimDamagePhotoTypes(getMotorbikePhohotos);
    }

    public render() {
        if (!isMobile) {
            if (!this.props.claimSubmit.continueOnMobile) { this.props.dispatchSetStep(1, 4); }
            return (
                <div className="ssp-container-fnol-switch-to-your-phone">
                     <div className="row fnol-switch-to-mobile-row">

                        <div className="col fnol-switch-to-mobile-col-text">
                            <div className="ssp-header-fnol-switch-to-your-phone">
                                <h3>
                                    Switch to your phone to continue
                                </h3>
                                <p>
                                    To take photos of your claim, &nbsp;
                                    <br/>
                                    please use your phone
                                </p>                            
                            </div>
                            <span className="fnol-switch-to-mobile-follow-steps-header">
                                Follow these steps:
                            </span>
                            <ul className="fnol-switch-to-mobile-follow-steps-ul">
                                <li><span className="fnol-switch-to-mobile-step-li-header">Step 1</span>You’ll receive an SMS with a link to our self-service portal. Tap on the link to continue.</li>
                                <li><span className="fnol-switch-to-mobile-step-li-header">Step 2</span>Log into your account.</li>
                                <li><span className="fnol-switch-to-mobile-step-li-header">Step 3 </span>You’ll get a pop-up asking you if you want to continue with the claim you started. Tap ‘Continue’. </li>
                                <li><strong>Please note:</strong> You'll have 1 hour (from when you receive our SMS) to continue with your claim. Once this hour's up, you'll need to go to the 'Claims' tab on the menu and tap on 'Submit a claim' to start the claim again.</li>
                            </ul>
                        </div>
                        <div className="fnol-switch-to-mobile-col-img">
                            <img src="/my-policy/Images/FNOL/fnol-switch-to-your-phone-370px.png" alt="" title="" />
                        </div>
                    </div>
                    <hr className="hr-minus20px" />
                    <div className="noma row">
                        <div className="col fnol-switch-to-mobile-buttonholder">
                            <p>Don’t want to switch? That’s fine, just tap here:</p>
                            <button className="btn btn-outline-red w-100" onClick={this.handleIsDrivable}>Continue on desktop</button>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            this.handleIsDrivableMobile();
            this.props.dispatchSetStep(1, 4);
            return (
                <div></div>
            )
        }
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchSetIsCar: (isCar) => dispatch(setIsCar(isCar)),
        dispatchGetClaimDamagePhotoTypes: (riskItemType) => dispatch(getClaimDamagePhotoTypes(riskItemType)),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FnolStep1Sub3)